import { Box } from "@mui/material";
import React, { useState } from "react";
import Text from "./text/Text";
import { accountFeesInfo, speedFee as speedFeeTxt } from "./messages";
import ErrorIcon from "@mui/icons-material/Error";
import { CustomPopper } from "./popper/Popper";
import { getSpeedFeeLabel } from "./constants";

function SpeedFeeComponent({ isFromBrowser, speedFee, fixedFee }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      mt={isFromBrowser ? "16px" : "12px"}
      mb={isFromBrowser ? "16px" : "10px"}
    >
      <Text className="grey-text" size={isFromBrowser ? 14 : 12} font="regular">
        {getSpeedFeeLabel({
          speedFeePercentage: speedFee,
          speedFixedFees: fixedFee,
        })}
      </Text>
      <ErrorIcon
        aria-describedby={"account-fee"}
        sx={{
          height: "18px",
          width: "18px",
          color: "#A4A9B7 !important",
          marginLeft: "4px",
        }}
        onClick={(e) => handleClick(e)}
      />

      <CustomPopper
        id="account-fee"
        disablePortal={true}
        open={open}
        anchorEl={anchorEl}
        position="top"
        handleClose={() => setAnchorEl(null)}
        sx={{ width: isFromBrowser ? "332px" : "253px" }}
      >
        <Text variant="inherit" font="regular" size={isFromBrowser ? 16 : 14}>
          {accountFeesInfo}
        </Text>
      </CustomPopper>
    </Box>
  );
}

export default SpeedFeeComponent;
